import styled from '@emotion/styled';
import { Link } from 'src/domains/layouts/webview/components/router/NewLink';
import { withConfig } from 'src/withConfig';
import { LiveTvIcon } from 'src/domains/layouts/shared/assets/icons/other/LiveTxIcon';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { css, SerializedStyles } from '@emotion/react';

interface CardHeaderWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setCardHeaderWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            margin-bottom: 8px;
            border-radius: ${theme.star.radius.medium};
            background: ${theme.star.racingNextOff.raceBox.bgColorQuinary};
        `;
    }
    return css`
        background-color: ${theme.star.racingNextOff.raceBox.bgColorSecondary};
    `;
};

export const CardHeaderWrapper = withConfig(theme => styled(Link, { label: 'CardHeaderWrapper' })<CardHeaderWrapperPropsType>`
    ${({ variant }): SerializedStyles => setCardHeaderWrapper(variant, theme)}
    box-shadow: 0 1px 0 0 ${theme.star.racingNextOff.raceBox.borderColor};
    color: ${theme.star.racingNextOff.raceBox.txtColorTertiary};
    display: flex;
    gap: 8px;
    height: 44px;
    overflow: hidden;
    padding: 8px 12px;
    text-decoration: none;
`);

export const CardHeaderStreamIco = withConfig(theme => styled(LiveTvIcon, { label: 'CardHeaderStreamIco' })`
    align-self: start;
    fill: ${theme.star.racingNextOff.raceBox.bgColorQuaternary};
    flex: 0 0 16px;
    width: 16px;
`);

export const CardHeaderData = styled('div', { label: 'CardHeaderData' })`
    display: flex;
    flex-flow: row wrap;
    flex: 1 1 auto;
    overflow: hidden;
`;

export const CardHeaderRaceName = withConfig(theme => styled('div', { label: 'CardHeaderRaceName' })`
    flex: 1 1 100%;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.3334;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`);

export const CardHeaderRaceMeta = withConfig(theme => styled('div', { label: 'CardHeaderRaceMeta' })`
    color: ${theme.star.racingNextOff.raceBox.txtColorQuaternary};
    position: relative;
    font-size: ${theme.star.fontSize.xSmall};
    line-height: 1.2;
    &:not(:last-of-type) {
        &::after {
            content: '/';
            margin: 0 4px;
        }
    }
`);
